import {createFileRoute} from "@tanstack/react-router";
import {healthSearchValidator} from "./-model";
import {HealthPage} from "./-page";
export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/ottosync-health")({
    validateSearch: (search) => healthSearchValidator.parse(search),
    loader: ({context}) => ({accessToken: context.authenticationStatus.accessToken, intellsysBaseUrl: context.intellsysBaseUrl}),
    component: HealthPage,
});
